// Configuración del servidor API
// Para desarrollo local: usa 'http://localhost:3001'
// Para producción: usa 'http://remuneraciones.unsaac.edu.pe:3001'

const API_URL = process.env.REACT_APP_API_URL || 'https://remuneraciones.unsaac.edu.pe/api';

export default API_URL;
